import Tenant10 from "./kopken.webp";
import Tenant12 from "./alfamaret.webp";
import Tenant13 from "./indomaret.webp";
import Tenant14 from "./anomali.webp";
import Tenant15 from "./foodhall.webp";

const tenant2images = [Tenant10, Tenant12, Tenant13, Tenant14, Tenant15];

export default tenant2images;
